import httpClient from "@/_shared/http-client";
import responseAdapter from "@/business/api-services/_responseAdapter";
import urlBuilder from "@/business/api-services/_urlBuilder";

const getAdded = async (providerId = 1, products = {}) => {
  const results = {
    records: [],
  };
  const fullUrl = urlBuilder.buildForProductsTab(providerId, products.removing);
  await httpClient.get(fullUrl).then(({ data }) => {
    results.records = responseAdapter.adaptForProductsTab(data.records);
  });
  return results;
};

const getRemained = async (tableName, params = {}) => {
  let url = new URL(`${process.env.BACKEND_URL}/records/${tableName}`);
  url.searchParams.set('page', params.page);
  if (params.search) {
    const { criterion, query } = params.search;
    url.searchParams.set('filter', `${criterion},cs,${query}`);
  }
  let results = {};
  await httpClient.get(url).then(({ data }) => results = data);
  return results;
};

export const providerProductsService = {
  getAdded,
  getRemained,
};



// WEBPACK FOOTER //
// ./src/business/api-services/providerProductsService.js